import api from '../../../../App/socket';

export const changeUserPhone = (user_id, name, phone, phone_id) => (
    api.send({
        api: 'db',
        model: 'User',
        action: 'NestedUpdate',
        options: {
            where: {
                _id: user_id,
            },
            fullPath: `person.phones.${phone_id}`,
            update: { name, phone },
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/user_phones_requests/change_user_phone_request.js